import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Import translations
import translationEN from './locales/en/translation.json'; // English
import translationRU from './locales/ru/translation.json'; // Russian
const resources = {
  en: {
    translation: translationEN,
  },
  ru: {
    translation: translationRU,
  },
};
i18n.use(initReactI18next).init({
  resources,
  lng: 'en', 
  keySeparator: false, 
  interpolation: {
    escapeValue: false,
  },
});
export default i18n;